import { render } from "./OrderInvoiceItemForm.vue?vue&type=template&id=13f680da&scoped=true"
import script from "./OrderInvoiceItemForm.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceItemForm.vue?vue&type=script&lang=js"

import "./OrderInvoiceItemForm.vue?vue&type=style&index=0&id=13f680da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f680da"]])

export default __exports__